import React from 'react';
import { PostToggleCard, UpgradePlanCard } from '../../components';
import Dropdown from 'react-dropdown';
// import Dropdown from 'react-dropdown';

// const srcType = [
//   { value: '1', label: 'Icon' },
//   { value: '2', label: 'Name' }
// ];
let ppAuthor = [
  { value: 'full_name', label: 'Show Full Name' },
  { value: 'short_fname', label: 'Shorten First Name' },
  { value: 'short_lname', label: 'Shorten Last Name' },
  { value: 'short_uname', label: 'Shorten Full Name' },
  { value: 'hide', label: 'Hide' }
];

const PopupCard = ({
  cnf,
  currHtnpp,
  handleCnfChange,
  updatePopupById,
  popup,
  handleUpgradePlan
}) => {
  return (
    <div className="side-editor-panel side-editor-popup">
      <div className="card card-editor card-customize">
        <div className="card-editor card-template">
          <div className="card-editor-block">
            <label className="card-editor-title">Templates</label>
            <div className="template-list">
              {
                popup && popup.map((val, key) => {
                  return (
                    <div className={val._id == currHtnpp ? 'theme-layout-item theme-block active' : 'theme-layout-item theme-block'} key={key} onClick={() => updatePopupById(val._id)}>
                      <img src={val.iu} alt="theme" />
                    </div>
                  );
                })
              }
            </div>
          </div>
        </div>
      </div>
      <div className="card card-editor card-popupstg mt-15">
        <div className="card-editor-block p-0 ">
          <div className='card-plan-div'>
            <label className="card-editor-title">Popup Option</label>
            <UpgradePlanCard
              handleUpgradePlan={handleUpgradePlan}
            />
          </div>
          <div className="customize-list">
            {/* {cnf && cnf.ppiat != undefined &&
              <PostToggleCard
                ttl={'Show author name'}
                fieldName={'ppiat'}
                value={cnf.ppiat}
                handleCnfChange={handleCnfChange} />
            } */}
            {cnf && cnf.ppiat != undefined &&
              <div className="editor-field-list editor-dropdown customize-dropdown customize-onclick">
                <label>Author name</label>
                <Dropdown style={{ width: '130px' }} className="nf-select-dropdown nf-select-defaultdd nf-select-authorname" options={ppAuthor} value={cnf.ppiat ? cnf.ppiat.toString() : cnf.ppiat} onChange={(e) => handleCnfChange('ppiat', e.value)} />
              </div>
            }
            {cnf && cnf.ppiauicn != undefined &&
              <PostToggleCard
                ttl={'Show author icon'}
                fieldName={'ppiauicn'}
                value={cnf.ppiauicn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.ppidtm != undefined &&
              <PostToggleCard
                ttl={'Show date'}
                fieldName={'ppidtm'}
                value={cnf.ppidtm}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.ppiact != undefined &&
              <PostToggleCard
                ttl={'Show action'}
                fieldName={'ppiact'}
                value={cnf.ppiact}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.ppisrc != undefined &&
              <PostToggleCard
                ttl={'Show source'}
                fieldName={'ppisrc'}
                value={cnf.ppisrc}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.ppicptn != undefined &&
              <PostToggleCard
                ttl={'Show caption'}
                fieldName={'ppicptn'}
                value={cnf.ppicptn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.ppwbstlg != undefined &&
              <PostToggleCard
                ttl={'Show website logo'}
                fieldName={'ppwbstlg'}
                value={cnf.ppwbstlg}
                handleCnfChange={handleCnfChange} />
            }

            {/* Job board */}
            {cnf && cnf.jbppittl != undefined &&
              <PostToggleCard
                ttl={'Show job title'}
                fieldName={'jbppittl'}
                value={cnf.jbppittl}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.jbppilctn != undefined &&
              <PostToggleCard
                ttl={'Show location'}
                fieldName={'jbppilctn'}
                value={cnf.jbppilctn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.jbppislry != undefined &&
              <PostToggleCard
                ttl={'Show salary'}
                fieldName={'jbppislry'}
                value={cnf.jbppislry}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.jbppidsc != undefined &&
              <PostToggleCard
                ttl={'Show description'}
                fieldName={'jbppidsc'}
                value={cnf.jbppidsc}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.jbppidsgn != undefined &&
              <PostToggleCard
                ttl={'Show designation'}
                fieldName={'jbppidsgn'}
                value={cnf.jbppidsgn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.jbppiskl != undefined &&
              <PostToggleCard
                ttl={'Show skill'}
                fieldName={'jbppiskl'}
                value={cnf.jbppiskl}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.jbppityp != undefined &&
              <PostToggleCard
                ttl={'Show job type'}
                fieldName={'jbppityp'}
                value={cnf.jbppityp}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.jbppicta != undefined &&
              <PostToggleCard
                ttl={'Show CTA'}
                fieldName={'jbppicta'}
                value={cnf.jbppicta}
                handleCnfChange={handleCnfChange} />
            }

            {/* [S] Team_showcase */}
            {cnf && cnf.tmppiimg != undefined &&
              <PostToggleCard
                ttl={'Show image'}
                fieldName={'tmppiimg'}
                value={cnf.tmppiimg}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.tmppinm != undefined &&
              <PostToggleCard
                ttl={'Show name'}
                fieldName={'tmppinm'}
                value={cnf.tmppinm}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.tmppieml != undefined &&
              <PostToggleCard
                ttl={'Show email'}
                fieldName={'tmppieml'}
                value={cnf.tmppieml}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.tmppiphn != undefined &&
              <PostToggleCard
                ttl={'Show phone'}
                fieldName={'tmppiphn'}
                value={cnf.tmppiphn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.tmppipstn != undefined &&
              <PostToggleCard
                ttl={'Show position'}
                fieldName={'tmppipstn'}
                value={cnf.tmppipstn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.tmppiwbst != undefined &&
              <PostToggleCard
                ttl={'Show website'}
                fieldName={'tmppiwbst'}
                value={cnf.tmppiwbst}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.tmppilctn != undefined &&
              <PostToggleCard
                ttl={'Show location'}
                fieldName={'tmppilctn'}
                value={cnf.tmppilctn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.tmppidsc != undefined &&
              <PostToggleCard
                ttl={'Show description'}
                fieldName={'tmppidsc'}
                value={cnf.tmppidsc}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.tmppiscl != undefined &&
              <PostToggleCard
                ttl={'Show social profile'}
                fieldName={'tmppiscl'}
                value={cnf.tmppiscl}
                handleCnfChange={handleCnfChange} />
            }
            {/* [E] Team_showcase */}

            {/* [S] tool_youtube_gallery */}
            {cnf && cnf.vidppiplyicn != undefined &&
              <PostToggleCard
                ttl={'Show play icon'}
                fieldName={'vidppiplyicn'}
                value={cnf.vidppiplyicn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.vidppidrtn != undefined &&
              <PostToggleCard
                ttl={'Show duration'}
                fieldName={'vidppidrtn'}
                value={cnf.vidppidrtn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.vidppittl != undefined &&
              <PostToggleCard
                ttl={'Show title'}
                fieldName={'vidppittl'}
                value={cnf.vidppittl}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.vidppidt != undefined &&
              <PostToggleCard
                ttl={'Show date'}
                fieldName={'vidppidt'}
                value={cnf.vidppidt}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.vidppidesc != undefined &&
              <PostToggleCard
                ttl={'Show description'}
                fieldName={'vidppidesc'}
                value={cnf.vidppidesc}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.vidppiviw != undefined &&
              <PostToggleCard
                ttl={'Show view counter'}
                fieldName={'vidppiviw'}
                value={cnf.vidppiviw}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.vidppilk != undefined &&
              <PostToggleCard
                ttl={'Show like counter'}
                fieldName={'vidppilk'}
                value={cnf.vidppilk}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.vidppicmnt != undefined &&
              <PostToggleCard
                ttl={'Show commnents counter'}
                fieldName={'vidppicmnt'}
                value={cnf.vidppicmnt}
                handleCnfChange={handleCnfChange} />
            }
            {/* [E] tool_youtube_gallery */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupCard;


{/* <div class='WdGtmdl-modal' id='popup-main-div_{_ID}'>
  <div class="WdGtmdl-modal-centered">
    <div class='WdGtmdl-modal-content'>
      <div class='WdGtmdl-modal-close close-model-div' id='model-close-div'>
        <svg class='close-model-div' id='img-div-close' xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 51.976 51.977'>
          <g class='close-model-div' id='Group_7990' data-name='Group 7990' transform='translate(0 0)'>
            <circle class='close-model-div' fill='#FFFFFF' id='Ellipse_123' data-name='Ellipse 123' cx='22' cy='22' r='22' transform='translate(4 4)'></circle>
            <path class='close-model-div' fill='#8190A4' id='Path_12527' data-name='Path 12527' d='M44.373,7.6a26,26,0,1,0,0,36.77A26.03,26.03,0,0,0,44.373,7.6ZM36.241,36.241a2,2,0,0,1-2.828,0l-7.425-7.425L18.21,36.594a2,2,0,1,1-2.828-2.828l7.778-7.778-7.425-7.425a2,2,0,1,1,2.828-2.828l7.425,7.425,7.071-7.071a2,2,0,0,1,2.828,2.828l-7.071,7.071,7.425,7.425A2,2,0,0,1,36.241,36.241Z'></path>
          </g>
        </svg>
      </div>
      <div className="WdGtmdl-sdr-nav">
        <div className="WdGtmdl-sdr-control wdgtmdl-control-left" id='model-right-div'>
          <div className="WdGtmdl-sdr-circle">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style="fill: rgb(255, 255, 255);"><path fill-rule="evenodd" d="M8.96 1.96a1 1 0 011.497 1.32l-.083.094L5.747 8l4.627 4.626a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.32.084l-.094-.084-5.334-5.333a1 1 0 01-.083-1.32l.083-.094L8.96 1.96z"></path></svg>
          </div>
        </div>
        <div className="WdGtmdl-sdr-control wdgtmdl-control-left" id='model-left-div'>
          <div className="WdGtmdl-sdr-circle">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style="fill: rgb(255, 255, 255);"><path fill-rule="evenodd" d="M8.96 1.96a1 1 0 011.497 1.32l-.083.094L5.747 8l4.627 4.626a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.32.084l-.094-.084-5.334-5.333a1 1 0 01-.083-1.32l.083-.094L8.96 1.96z"></path></svg>
          </div>
        </div>
      </div>
      <div id='model-main-div_{_ID}'></div>
    </div>
  </div>
</div> 


<div class='upsdr-modal' id='popup-main-div_{_ID}'><div class='upsdr-modal-content'><div class='upsdr-modal-close close-model-div' id='model-close-div'> <svg class='close-model-div' id='img-div-close' xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 51.976 51.977'> <g class='close-model-div' id='Group_7990' data-name='Group 7990' transform='translate(0 0)'> <circle class='close-model-div' fill='#FFFFFF' id='Ellipse_123' data-name='Ellipse 123' cx='22' cy='22' r='22' transform='translate(4 4)'></circle> <path class='close-model-div' fill='#8190A4' id='Path_12527' data-name='Path 12527' d='M44.373,7.6a26,26,0,1,0,0,36.77A26.03,26.03,0,0,0,44.373,7.6ZM36.241,36.241a2,2,0,0,1-2.828,0l-7.425-7.425L18.21,36.594a2,2,0,1,1-2.828-2.828l7.778-7.778-7.425-7.425a2,2,0,1,1,2.828-2.828l7.425,7.425,7.071-7.071a2,2,0,0,1,2.828,2.828l-7.071,7.071,7.425,7.425A2,2,0,0,1,36.241,36.241Z'> </path> </g> </svg></div><div id='model-right-div'> <span>Right</span></div><div id='model-left-div'> <span>Left</span></div><div id='model-main-div_{_ID}'></div></div></div>

*/}


// WEBPACK FOOTER //
// ./src/components/Widget/PopupCard.js